import { useGlobalContext } from "./Context"
import { useState } from "react"
import { useNavigate } from 'react-router-dom';
import { Input, Alert, Typography, Col, Row } from 'antd';

const { Title } = Typography;
const { Search } = Input;

const Home = () => {
    const [validationError, setValidationError] = useState(false);
    const { setSearchKeyword } = useGlobalContext();
    const navigate = useNavigate();
    const onSearch = (value, _e, info) => {
        search(value);
    }

    const onSubmit = (e) => {
        search(e.target.value);
    }

    var search = (searchText) => {
        if (!searchText || searchText.trim().length < 3) {
            setValidationError(true);
            return;
        }

        console.log(`Set search text to be - ${searchText}`);
        setSearchKeyword(searchText.trim());
        navigate('/search');
    }

    return (
        <>
            <Row>
                <Col span={24}
                    style={{
                        textAlign: "center",
                        marginTop: "20px",
                    }}>
                    <Title>Food Grade New Zealand</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}
                    style={{
                        textAlign: "center",
                        marginTop: "20px",
                    }}>
                    <Title level={4}>Ensure hygiene before you order.</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}
                    style={{
                        textAlign: "center",
                        marginTop: "20px",
                    }}>
                    <Search
                        placeholder="Enter the restaurant or street name"
                        allowClear
                        enterButton="Search"
                        size="large"
                        style={{
                            width: "80%",
                        }}
                        onSearch={onSearch}
                        onPressEnter={onSubmit}
                    />
                </Col>
            </Row>
            <Col span={24}
                style={{

                    marginTop: "20px",
                }}>
                {validationError && (
                    <Alert
                        message="The search keywords must be longer than 3 characters."
                        type="warning"
                    />
                )}
            </Col>
        </>
    );
}

export default Home;
